import { render } from "./firstProject.vue?vue&type=template&id=120fe649"
import script from "./firstProject.vue?vue&type=script&lang=js"
export * from "./firstProject.vue?vue&type=script&lang=js"

import "./firstProject.vue?vue&type=style&index=0&id=120fe649&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__